exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".workloads-pivot-data .bolt-header-default {\n  padding-bottom: 12px; }\n", ""]);

// exports
